var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRaisedHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Hand_Raise_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hand_Raise_",
    "data-name": "Hand Raise ",
    clipPath: "url(#clip-Hand_Raise_)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_770",
    "data-name": "Group 770",
    transform: "translate(-2744 -1807)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_628",
    "data-name": "Ellipse 628",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(2744 1807)",
    className: "icon-background"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-hand",
    "data-name": "Icon ionic-ios-hand",
    d: "M27.766,8.248A1.472,1.472,0,0,0,26.283,9.7v7.692a.626.626,0,0,1-1.252,0V6.04a1.484,1.484,0,0,0-2.967,0v8.916a.626.626,0,0,1-1.252,0V4.823a1.484,1.484,0,0,0-2.967,0V16.172a.626.626,0,0,1-1.252,0V7.256a1.484,1.484,0,0,0-2.967,0V22.605l-1.955-1.659c-1.835-1.6-3.389-2.278-4.655-1.1-.851.83.485,2.173,1.884,3.741,1.35,1.512,4.922,6.462,7.966,8.248a5.489,5.489,0,0,0,2.855.8h4.022c3.241,0,5.512-2.665,5.512-6.553V9.7A1.483,1.483,0,0,0,27.766,8.248Z",
    transform: "translate(2747.961 1813.299)",
    className: "icon-foreground"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaisedHand);
export default __webpack_public_path__ + "static/media/raisedHand.1895eb0582e49a20831cc63bda21c52d.svg";
export { ForwardRef as ReactComponent };